import { Empty } from "antd";

function PDFPage8Table4(props: any) {
    return (
        <>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-12">
                <thead className="cu-bg-green  ">
                    <tr>
                        <th className="fw-600">{props.TranslateString(`Yritykset / Company shareholders **`)}</th>
                        <th className="text-left fw-600">{props.TranslateString('Business Id')}</th>
                        <th className="text-right fw-600">{props.TranslateString('num_of_apartments_pdf')}</th>
                        <th className="text-right fw-600">{props.TranslateString('Autopaikat lkm')}</th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("number_of_other_spaces")}</th>
                        <th className="text-right fw-600">{props.TranslateString('the_percentage_of_the_shares_owned_of_hc')}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    {props.data?.length > 0 ? props.data?.map((val: any) => {
                        return (<tr className='text-left' key={Math.random()}>
                            <td >{val?.shareholder_name}</td>
                            <td className="">{val?.business_id}</td>
                            <td className="text-right">{val?.no_of_apartments}</td>
                            <td className="text-right">{val?.no_of_carspaces || "0"}</td>
                            <td className="text-right">{val?.no_of_other_spaces|| "0"}</td>
                            <td className="text-right">{val?.total_shares}</td>
                        </tr>)
                    }) : <tr><td colSpan={6}><Empty description={props.TranslateString('Empty')}/></td></tr>}
                </tbody>
                <tfoot>
                    {props.data?.length > 0 && props.total ?
                        <tr className='bg-light'>
                            <td className='text-capitalize fw-600'>{props.TranslateString('Total')}</td>
                            <td className="text-right fw-600"></td>
                            <td className="text-right fw-600">{props?.total?.total_no_of_apartments}</td>
                            <td className="text-right fw-600">{props?.total?.total_no_of_car_spaces}</td>
                            <td className="text-right fw-600">{props?.total?.total_no_of_other_spaces}</td>
                            <td className="text-right fw-600">{props?.total?.total_percentage_of_shares || "0 %"}</td>
                        </tr>
                        : ""} 
                </tfoot>
            </table>
        </>
    );
}

export default PDFPage8Table4;